<template>
  <div class="form-report-to-ctba" id="form-report-to-ctba" v-if="showComponent">
    <div class="rtc-hd">
      <h3 class="rtc-title">推送到公共服务平台（国家）</h3>
    </div>
    <div class="rtc-bd">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="IS_REPORT_CTBA">
          <el-radio-group v-model="form.IS_REPORT_CTBA" @change="togglePush" class="rtc-radio">
            <el-radio :label="true">推送</el-radio>
            <el-radio :label="false">不推送</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="rtc-remark" v-if="form.IS_REPORT_CTBA">
          推送签章时请核对招标公告内容为最终版本。<br />
          项目发布后，请等待2小时再到国家服务平台查看。 （网址：<a href="http://www.cebpubservice.com/" target="_blank"
            >http://www.cebpubservice.com/</a
          >）
        </div>
        <div class="rtc-form" v-if="form.IS_REPORT_CTBA">
          <p class="rtc-p">
            <el-form-item prop="IS_REPORT_CTBA_NAME" label="招标人或其招标代理机构主要负责人（项目负责人）：">
              <el-input class="rtc-input" v-model="form.IS_REPORT_CTBA_NAME"></el-input>
              <el-button type="primary" @click="signTenderContent" :loading="loading">推送签章</el-button>
            </el-form-item>
          </p>
          <bear-sign :options="options" :isSign="true" :isRefresh="false" @pdfSignMethod="pdfSignMethod"></bear-sign>
          <el-form-item prop="NOTICE_CONTENT_ATTACHMENTS_PDF">
            <bear-file-list :file-list="form.NOTICE_CONTENT_ATTACHMENTS_PDF" :is-edit="true" @delFile="delFile"> </bear-file-list>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { tenderProjectConfig } from "@store/tender/modules/waterStore";
import { mapState, mapActions, mapMutations } from "vuex";
import { ElMessageBox } from "element-plus";
import utils from "~@/common/js/utils";
import BearFileList from "~@/file-list/src";
import { getUrlParams, createUniqueId } from "@/common/js/utils";
export default {
  name: "BearReportToCtba",
  components: { BearFileList },
  data() {
    return {
      loading: false,
      key: "",
      options: {
        result: false,
        json: {},
      },
      CTBA_AREA: tenderProjectConfig.CTBA_AREA,
      rules: {
        IS_REPORT_CTBA: [{ required: true, message: " " }],
        IS_REPORT_CTBA_NAME: [{ required: true, message: " " }],
        NOTICE_CONTENT_ATTACHMENTS_PDF: [{ required: true, type: "array", message: "请点击按钮推送签章文件到公共服务平台" }],
      },
    };
  },
  computed: {
    ...mapState(["form", "count", "commitAction", "isTraffic"]),
    allValid() {
      let { success, total } = this.count;
      return success === total;
    },
    isHouse() {
      return location.pathname.indexOf('house') >= 0
    },
    showComponent() {
      let { CTBA_AREA, isHouse, form, isTraffic } = this;
      let { REGION_CODE, regionId, IS_REPORT_CTBA, NOTICE_CONTENT_ATTACHMENTS_PDF } = form;
      let flag =
        (regionId && REGION_CODE && /^(65|35)\d{4}$/.test(REGION_CODE) && CTBA_AREA.indexOf(form.regionId) != -1) ||
        regionId == "x91000";
      if (isHouse) flag = regionId && ['x30001', 'x00004', 'x50002', 'x60004', 'x60011', 'x350104', 'x350203'].indexOf(regionId) >= 0
      if (flag) {
        if (IS_REPORT_CTBA === undefined) this.form.IS_REPORT_CTBA = "";
        if (NOTICE_CONTENT_ATTACHMENTS_PDF === undefined) this.form.NOTICE_CONTENT_ATTACHMENTS_PDF = [];
      }
      if (isTraffic) flag = false
      return flag;
    },
  },
  watch: {
    "form.IS_REPORT_CTBA"(n, o) {
      let { form } = this;
      if (n && (!this.allValid || !form.canIPublish)) {
        ElMessageBox({
          title: "操作提示",
          customClass: "ctba-message-info",
          type: "info",
          message: "为减少您信息录入，请先完成项目信息的必填项、填写日程安排，再点击推送按钮。",
        }).catch(e => null);
        form.IS_REPORT_CTBA = o;
      }
    },
  },
  created() {
    let { form } = this;
    if (!form.NOTICE_CONTENT_ATTACHMENTS_PDF) {
      form.NOTICE_CONTENT_ATTACHMENTS_PDF = [];
    }
    this.setVm(this);
  },
  methods: {
    ...mapMutations(["setSignUrlOptions"]),
    ...mapMutations("reportToCTBA", ["setVm"]),
    ...mapActions(["doSaveTemp"]),
    ...mapActions("reportToCTBA", ["reportToCTBA", "getAttachInfo"]),
    signTenderContent() {
      let { allValid, form, commitAction } = this;
      let { canIPublish, IS_REPORT_CTBA, IS_REPORT_CTBA_NAME } = form;

      if (allValid && canIPublish && IS_REPORT_CTBA && IS_REPORT_CTBA_NAME) {
        this.loading = true;
        this.doSaveTemp({
          form: form,
          obj: commitAction,
          call: () => {
            this.getSignContent();
          },
        });
      } else {
        ElMessageBox("请先完成项目信息的必填项、填写日程安排，再点击推送签章按钮", "提示", {
          type: "info",
        });
      }
    },
    genID(length) {
      if(__type__ === 'water') {
        return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
      } else {
        return createUniqueId()
      }
    },
    getSignContent() {
      let params = getUrlParams();
      this.key = this.genID(16);
      this.reportToCTBA({
        key: this.key,
        caExtraData: "extra_filetype=pdf",
        foId: params.foId,
        data: JSON.stringify({
          url: "/tendercontent/notice?tpid=" + params.foId + "&to=CTBA",
        }),
      }).then((res) => {
        this.loading = false;
        // this.setSignUrlOptions(res);
        this.options = res;
      });
    },
    pdfSignMethod() {
      let params = getUrlParams();
      this.getAttachInfo({
        key: this.key,
        foId: params.foId,
      }).then((res) => {
        this.form.NOTICE_CONTENT_ATTACHMENTS_PDF = [
          {
            name: "推送签章附件",
            md5: res.json ? res.json.Key : "",
            sdpUrl: res.json ? res.json.sdpUrl : "",
            url: res.json ? res.json.sdpUrl : "",
          },
        ];
        // console.log(this.form.NOTICE_CONTENT_ATTACHMENTS_PDF);
      });
    },
    delFile() {
      this.form.NOTICE_CONTENT_ATTACHMENTS_PDF = [];
    },
    togglePush(val) {
      let { form } = this;
      form.NOTICE_CONTENT_ATTACHMENTS_PDF = [];
    },
    validForm(call) {
      if (this.showComponent) {
        this.$refs.form.validate((valid, invalidFields) => {
          call && call(valid, invalidFields);
        });
      } else {
        call && call(true);
      }
    },
    scrollIntoView() {
      this.$refs.form.$el.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-report-to-ctba {
  width: 900px;
  margin: 0 auto 15px;
  box-sizing: border-box;
  background: white;
  box-shadow: 0px 0px 5px 1px #aaabaf;
  border: 1px solid #20a0ff;
  .rtc-hd {
    position: relative;
    text-align: center;
    color: white;
    background: #20a0ff;
    .rtc-title {
      margin: 0;
      font: bold 20px/50px microsoft yahei;
    }
  }
  .rtc-bd {
    margin-top: 15px;
    padding: 0px 30px 30px;
    font: normal 14px/23px microsoft yahei;
    transition: all cubic-bezier(0.68, -0.55, 0.265, 1.55);
    .rtc-radio {
      margin: 5px 0;
    }
    .rtc-remark {
      &,
      a {
        color: #999999;
      }
    }
    .rtc-input {
      display: inline-block;
      width: 180px;
      margin-right: 5px;
    }
  }
  .red {
    color: red;
  }
}
</style>